<template>
  <GlobalAlertWindow
    v-loading="isUploading"
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules" label-width="120px" label-suffix="："  inline>
      <p class="tip-warn" style="margin: 30px;font-size: 14px;"><i class="el-icon-warning"></i>操作说明：您正在针对订单：<span class="red">{{ form.code }} </span>进行{{ form.status==2?'快递变更':'发货' }}操作！</p>
      <el-form-item label="快递公司" prop="kdId">
        <el-select
          v-model="form.kdId"
          filterable
          clearable
          placeholder="请选择快递公司"
        >
          <el-option v-for="item in kd" :key="item.id" :value="item.id" :label="item.name" />
        </el-select>
      </el-form-item>
      <el-form-item label="快递单号" prop="kdCode">
        <el-input v-model="form.kdCode" placeholder="请输入快递单号"   v-trim/>
      </el-form-item>
      <el-form-item label="发货备注" prop="kdInfo">
        <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 4}" v-model="form.kdInfo" placeholder="请输入发货备注"   v-trim/>
      </el-form-item>

    </el-form>
  </GlobalAlertWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalAlertWindow from '@/components/common/GlobalAlertWindow'
import {orderSendOutGoods} from '@/api/business/goodsorder'
export default {
  name: 'OperaShipmentsWindow',
  extends: BaseOpera,
  components: { GlobalAlertWindow },
  data () {
    return {
      isUploading: false,
      // 表单数据
      form: {
        id: null,
        code: '',
        status: '',
        kdId: '',
        kdInfo: '',
        kdCode: '',
        kdName: ''
      },
      kd: [],
      // 验证规则
      rules: {
        kdId: [
          { required: true, message: '请选择快递公司' }
        ],
        kdCode: [
          { required: true, message: '请输入快递单号' }
        ]
      }
    }
  },

  created () {
    this.config({
      api: '/business/labels',
      'field.id': 'id'
    })
  },
  mounted () {
    this.api.findAll({ status: 0, type: 17 })
      .then(res => {
        this.kd = res
      })
  },
  methods: {
    // 上传图片
    confirm () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return
        }
        this.isWorking = true
        var kd = this.kd.find(item => item.id === this.form.kdId)
        this.form.kdName = kd.name
        orderSendOutGoods(this.form)
          .then(() => {
            this.visible = false
            this.$tip.apiSuccess('添加成功')
            this.$emit('success')
          }).catch(e => {
            this.$tip.apiFailed(e)
          })
          .finally(() => {
            this.isWorking = false
          })
        // 调用新建接口
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/alertstyle.scss";

.tips-style {
  font-size: 16px;
  span {
    font-weight: 500;
  }
  margin-bottom: 10px;
}

::v-deep .el-select {
  width: 100%;
  .el-input__inner {
    width: 100%;
  }
}

</style>
